import { getState } from "../../state/store";
import { selectCognitoUser, selectUserRoles } from "../../state/selectors";

import {
  accessPageRequirements,
  accessPages,
  appTypeAvailabilityRoles,
  appUserRoles,
  routePathsWithParams,
  storage
} from "../../consts";
import routePaths from "../../consts/routePaths";
import { objectUtil } from "../../utils";

const env = process.env.REACT_APP_ENVIRONMENT;
const isProd = env === "prd";

const hasRole = (role) => {
  const userRoles =
    selectCognitoUser()(getState())?.signInUserSession.idToken.payload["cognito:groups"] || [];

  return userRoles.includes(role);
};

const isAdmin = () => {
  return hasRole(appUserRoles.Admin);
};

const getRoles = () => {
  return selectUserRoles()(getState());
};

const getAvailableRoutes = (roles) => {
  const filteredUserRoles = objectUtil.objFilterByKeys(accessPages, roles);

  let availableRoutes = [];
  Object.values(filteredUserRoles).forEach((arr) => availableRoutes.push(...arr));

  if (isProd) {
    availableRoutes = availableRoutes.filter((route) => !["/hardware"].includes(route));
  }

  return availableRoutes.filter((route) => getRouteAvailability(route));
};

const getRouteAvailability = (route) => {
  const requirement = accessPageRequirements[route];

  return requirement ? requirement() : true;
};

const getLoginRedirectUrl = (roles) => {
  const pathname = localStorage.getItem(storage.PATHNAME);

  if (pathname && pathname !== routePaths.ROOT) {
    const availableRoutes = getAvailableRoutes(roles);

    const mainRoute = pathname.split("/").slice(0, -1).join("/");

    const paramsAllowed = routePathsWithParams.includes(mainRoute);

    if (availableRoutes.includes(paramsAllowed ? mainRoute : pathname)) {
      return pathname;
    }
  }

  if (roles.includes(appUserRoles.Admin) || roles.includes(appUserRoles.ApplicationManager)) {
    return routePaths.USERS;
  }

  if (roles.includes(appUserRoles.ContentManager)) {
    return routePaths.APPS;
  }

  if (roles.includes(appUserRoles.FleetManager)) {
    return routePaths.NOTIFICATIONS;
  }

  return routePaths.DASHBOARD;
};

const getAppTypeSelectionAvailability = () => {
  const userRoles = getRoles();

  return userRoles.some((x) => appTypeAvailabilityRoles.includes(x));
};

const appUserService = {
  hasRole,
  isAdmin,
  getRoles,
  getLoginRedirectUrl,
  getAvailableRoutes,
  getAppTypeSelectionAvailability
};

export default appUserService;
